import { nanoid } from 'nanoid';

const init = ({ pieces, setWorkers, serverCall }) => {
  let newId = nanoid();
  let timer = null;

  const checkStatus = async () => {
    try {
      let res = await serverCall({ method: 'GET', url: `/services/cc-plan/status/${pieces.jobId}`, eamsAuth0: true });

      if(res.status !== 200) {
        clearInterval(timer);
        alert('Error checking conversion status. Contact support.');
        return;
      }

      let job = res.data;

      setWorkers((prev) => {
        const updatedWorkers = {...prev};
        updatedWorkers[newId].data = { status: job.status };
        return updatedWorkers;
      });

      if(job.status === 'error') {
        clearInterval(timer);
        alert('Error converting plan. Contact support.');
        return;
      }

      if(job.status === 'finished') {
        clearInterval(timer);
        let tasks = job.tasks;
        let found = tasks.find(x => x.name === 'export-my-file');
        let value = pieces.value;
        let files = found.result.files;

        if(pieces.subtype === 'plan upload') {
          let saveRes = await serverCall({ method: 'POST', data: { value, files }, url: `/mapping/plans/`, eamsAuth0: true });
          pieces.setPlans((prev) => [...prev, ...saveRes.data.plans]);
          pieces.setPhasePlans((prev) => [...prev, ...saveRes.data.phasePlans]);
        } else if(pieces.subtype === 'plan replacement') {
          let saveRes = await serverCall({ method: 'POST', data: { value, files }, url: `/mapping/plans/swap`, eamsAuth0: true });
          pieces.setPhasePlans((prev) => {
            let arr = [...prev];
            let idx = arr.findIndex(x => x.id === saveRes.data.id);
            arr[idx] = saveRes.data;
            return arr;
          });
        }
      }
    } catch(err) {
      console.log(err);
    }
  };

  checkStatus();
  timer = setInterval(checkStatus, 2000);

  setWorkers((prev) => ({ ...prev,
    [newId]: {
      worker: { terminate: () => clearInterval(timer) },
      type: 'plan upload',
      name: pieces.name,
      data: { status: 'starting', progress: 0 }
    }
  }));
}

export default init;
